import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { individualAssignmentsStateConfig } from "../../../../consts";

const teacherAssignmentsCrudMetaReducer = makeCrudStateReducer(
  individualAssignmentsStateConfig
);

export default teacherAssignmentsCrudMetaReducer;
